import styles from './Pricing.module.css';
import pricing_illustration from '../../assets/img_pricing.png';

export default function Pricing() {
    return (
        <main>
            <section className={styles.pageSection} aria-label="요금 안내">
                <div className={styles.content}>
                    {/* <h1 className={styles.title}>요금안내</h1> */}
                    <h2 className={styles.subtitle}>FirST SIM 요금안내</h2>
                    <p className={styles.desc}>
                        합리적인 요금으로 화재 확산 시뮬레이션 서비스를 사용하세요. 서비스 모델에 책정된 가격과 고객 유형별 상품 조합으로 서비스를 제공합니다.
                        <br />
                    </p>
                </div>
                <div className={styles.image}>
                    <img src={pricing_illustration} alt="요금 안내 일러스트" />
                </div>
            </section>

            <section className={styles.pricingTableSection} aria-label="요금제 안내">
                <div className={styles.pricingTableHeader}>
                    <h3 className={styles.tableTitle}>요금제 구조</h3>
                    <p className={styles.tableLead}>
                        FirST SIM은 모델별로 가격이 책정되며, 선택한 모델들의 가격 합계(P)를 기준으로 고객 유형 및 조직 규모에 따라 최종 요금이 산정됩니다.
                    </p>
                </div>

                <div className={styles.tableScroll}>
                    <table className={styles.pricingTable}>
                        <thead>
                            <tr>
                                <th>요금제 이름</th>
                                <th style={{ textAlign: 'center' }}>고객 유형</th>
                                <th style={{ textAlign: 'center' }}>사용자 수 기준</th>
                                <th>요금 계산 방식</th>
                                <th>비고</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Basic Plan</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>개인</td>
                                <td style={{ textAlign: 'center' }}>1명</td>
                                <td>종량제 요금</td>
                                <td>트래픽과 스토리지 사용량에 따른 가격 산정</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Personal Plan</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>개인</td>
                                <td style={{ textAlign: 'center' }}>1명</td>
                                <td>
                                    월 요금 = <strong>P</strong>
                                </td>
                                <td>P = 선택한 모델들의 가격 합계</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Team Plan</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>조직</td>
                                <td style={{ textAlign: 'center' }}>5명 이하</td>
                                <td>
                                    월 요금 = <strong>P × 5 × 0.95</strong>
                                </td>
                                <td>5인 기본 패키지, 5% 할인</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Business Plan</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>조직</td>
                                <td style={{ textAlign: 'center' }}>50명 이하</td>
                                <td>
                                    월 요금 = <strong>P × 50 × 0.85</strong>
                                </td>
                                <td>50인 기본 패키지, 15% 할인</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Enterprise Plan</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>조직</td>
                                <td style={{ textAlign: 'center' }}>100명 이하</td>
                                <td>
                                    월 요금 = <strong>P × 100 × 0.70</strong>
                                </td>
                                <td>100인 기본 패키지, 30% 할인</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Enterprise Plus</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>조직</td>
                                <td style={{ textAlign: 'center' }}>100명 초과</td>
                                <td>
                                    <strong>별도 문의</strong>
                                </td>
                                <td>조직 규모에 맞춘 맞춤 견적</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Education Plan</strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>교육기관</td>
                                <td style={{ textAlign: 'center' }}>10명 이상</td>
                                <td>
                                    <strong>별도 문의</strong>
                                </td>
                                <td>교육기관에 맞춘 맞춤 견적</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p className={styles.tableNote}>
                    ※ <strong>P</strong> = 고객이 선택한 모델들의 월 기준 가격 합계입니다. 각 모델별 가격은 서비스 신청 시 확인 가능합니다.
                    <br />※ <strong>종량제 요금</strong> = traffic 1KB당 0.0005원 / storage 1KB당 0.001원 적용
                    <br />
                    <strong style={{ color: 'red' }}>※ 시범 기간동안(2026년 7월까지) 모든 요금제는 무료로 사용 가능합니다.</strong>
                    <br />
                </p>
            </section>

            {/* <section className={styles.formWrap}>
                <div className={styles.formBox} role="form" aria-label="요금 계산기">
                    <div className={styles.row}>
                        <div className={styles.label}>고객 유형</div>
                        <div className={styles.opts}>
                            <label><input type="radio" name="userType" defaultChecked /> 일반 사용자</label>
                            <label><input type="radio" name="userType" /> 테넌트 관리자</label>
                        </div>
                    </div>

                    <div className={styles.row}>
                        <div className={styles.label}>이용 서비스</div>
                        <div className={styles.opts}>
                            <label><input type="checkbox" /> 서비스형 1</label>
                            <label><input type="checkbox" defaultChecked /> 서비스형 2</label>
                            <label><input type="checkbox" /> 서비스형 3</label>
                        </div>
                    </div>

                    <div className={styles.row}>
                        <div className={styles.label}>결제 방식</div>
                        <div className={styles.opts}>
                            <label><input type="radio" name="pay" defaultChecked /> 결제 방식 1</label>
                            <label><input type="radio" name="pay" /> 결제 방식 2</label>
                        </div>
                    </div>

                    <div className={styles.row}>
                        <div className={styles.label}>사용자 수는 얼마나 되나요?</div>
                        <input className={styles.input} type="number" min="1" placeholder="명" />
                    </div>

                    <div className={styles.actions}>
                        <button className={`${styles.btn} ${styles.primary}`}>확인</button>
                        <button className={`${styles.btn} ${styles.ghost}`}>취소</button>
                    </div>
                </div>
            </section> */}
        </main>
    );
}
